export const toINRCurrency = (value) => {
    const amount = Number(value);  // Converts string or number to number
    if (isNaN(amount)) return '₹0.00';  // Handle invalid input
    return amount.toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

export const capitalizeWords =(str)=> {
   if (!str) return '-';

  return str
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}